import styled from 'styled-components';

export const PanelContentContainer = styled.div<{ $isOpen: boolean }>`
    display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #b2b2b2;
    border-radius: 4px;
    padding: 15px;
    text-align: left;
    color: initial;

    .contextual-comments-panel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
    }

    .contextual-comments-panel-body {
        max-height: 500px;
        min-height: 400px;
        overflow-y: auto;
    }
`;
